import type { SkillRiskUnavailableReason } from '@kirin/api-client/contracts/skills';

/** Why a skill shows a dash in the Risk column (KIR-5099). */
export const SKILL_RISK_UNAVAILABLE_COPY: Record<
  SkillRiskUnavailableReason,
  string
> = {
  pending: 'Kirin is looking this skill up in AgentMesh. Check back shortly.',
  agentmesh_not_configured:
    'AgentMesh is not connected to this Kirin deployment, so skills are not looked up.',
  not_in_agentmesh:
    'AgentMesh has not scanned a skill with exactly these files. A skill written or edited locally, or a version AgentMesh has not collected, has no result.',
  unhashable:
    "The agent could not fingerprint this skill's folder, so it cannot be looked up in AgentMesh.",
  not_reported:
    'No fingerprint reported for this skill yet. Agents report one with each scan once they are updated.',
};

/** The agent's reason for an unhashable folder, for people. */
export function skillHashErrorText(hashError: string): string {
  if (hashError === 'too_large') {
    return 'The folder has more than 5,000 files or 256 MB.';
  }
  const reason = hashError.replace(/^unhashable:\s*/, '');
  return `Reason: ${reason}`;
}
